// import { RootStore } from 'mobx-stores'
import { ProductsTableBase, TriggerSearchFunc } from 'mobx-stores/utils'

export class ProductsTableStore extends ProductsTableBase {
  private rootStore: any

  constructor (rootStore: any) {
    super()
    this.rootStore = rootStore
  }

  // METHODS
  public triggerSearch: TriggerSearchFunc = async (options): Promise<void> => {
    const data = await this.rootStore.generalStore.api.productApi.allFilteredSorted(
      this.productFilter,
      { pageQueryParams: this.getPageQueryParams(options?.resetPageNumber) }
    )
    this.handleSearchResult(data)
  }
}
